/** Removes all the display characters from phone and returns a plain text */
export const stripPhoneSpecialCharacters = (ssn) => {
  return ssn
    .replace("(", "")
    .replace(")", "")
    .replace("-", "")
    .replace(" ", "");
};
